import es from "./translations/es";
import en from "./translations/en";
import it from "./translations/it";
import pt from "./translations/pt";
import fr from "./translations/fr";

export default {
  es,
  en,
  it,
  pt,
  fr
};
